import React from 'react';
import { Input } from 'reactstrap';
import { MdClose, MdArrowDropDown } from 'react-icons/md';

// Rows shown at once; the list scrolls for more
const LIST_MAX_HEIGHT = 250;

/**
 * Single select dropdown with search on the option label.
 * (multiselect-react-dropdown disables its search box in singleSelect mode.)
 *
 * props: options [{ value, label }], value, onChange(value), placeholder, disabled, emptyText
 */
class SearchableSelect extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            open: false,
            search: '',
            highlight: 0
        };
        this.container = React.createRef();
        this.list = React.createRef();
    }
    componentDidMount(){
        document.addEventListener('mousedown', this.handleOutsideClick);
    }
    componentWillUnmount(){
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }
    handleOutsideClick = (e) => {
        if(this.state.open && this.container.current && !this.container.current.contains(e.target)){
            this.close();
        }
    }
    getFiltered(){
        const search = this.state.search.trim().toLowerCase();
        if(!search) return this.props.options;
        return this.props.options.filter(option => option.label.toLowerCase().indexOf(search) != -1);
    }
    getSelected(){
        return this.props.options.find(option => option.value == this.props.value);
    }
    open = () => {
        if(this.props.disabled || this.state.open) return;
        this.setState({ open: true, search: '', highlight: 0 });
    }
    close(){
        this.setState({ open: false, search: '' });
    }
    select(option){
        this.props.onChange(option.value);
        this.close();
    }
    clear = (e) => {
        e.stopPropagation();
        this.props.onChange('');
        this.close();
    }
    handleSearchChange = (e) => {
        this.setState({ search: e.target.value, highlight: 0, open: true });
    }
    handleKeyDown = (e) => {
        const filtered = this.getFiltered();
        if(e.key == 'ArrowDown'){
            e.preventDefault();
            if(!this.state.open) return this.open();
            this.moveHighlight(Math.min(this.state.highlight + 1, filtered.length - 1));
        }else if(e.key == 'ArrowUp'){
            e.preventDefault();
            this.moveHighlight(Math.max(this.state.highlight - 1, 0));
        }else if(e.key == 'Enter'){
            // Don't submit the form while choosing
            e.preventDefault();
            if(this.state.open && filtered[this.state.highlight]) this.select(filtered[this.state.highlight]);
        }else if(e.key == 'Escape'){
            this.close();
        }else if(e.key == 'Tab'){
            this.close();
        }
    }
    moveHighlight(index){
        this.setState({ highlight: index }, () => {
            const item = this.list.current && this.list.current.children[index];
            if(item && item.scrollIntoView) item.scrollIntoView({ block: 'nearest' });
        });
    }
    render(){
        const { placeholder, disabled, emptyText } = this.props;
        const { open, search, highlight } = this.state;
        const selected = this.getSelected();
        const filtered = open ? this.getFiltered() : [];
        return (
            <div ref={this.container} style={{ position: 'relative' }}>
                <Input
                    type="text"
                    autoComplete="off"
                    // Closed: show the selected title. Open: the box is the search field
                    value={open ? search : (selected ? selected.label : '')}
                    placeholder={open && selected ? selected.label : placeholder}
                    disabled={disabled}
                    onFocus={this.open}
                    onClick={this.open}
                    onChange={this.handleSearchChange}
                    onKeyDown={this.handleKeyDown}
                    style={{ paddingRight: '3.5rem', cursor: disabled ? 'default' : 'text', backgroundColor: disabled ? undefined : '#fff' }}
                />
                <div style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center' }}>
                    {selected && !disabled &&
                        <span title="Clear" aria-label="Clear" role="button" onMouseDown={this.clear} style={{ cursor: 'pointer', marginRight: '0.25rem', display: 'flex' }} className="text-muted"><MdClose /></span>}
                    <MdArrowDropDown size={22} className="text-muted" onMouseDown={(e) => { e.preventDefault(); open ? this.close() : this.open(); }} style={{ cursor: disabled ? 'default' : 'pointer' }} />
                </div>
                {open &&
                <div ref={this.list} className="dropdown-menu show w-100" style={{ maxHeight: LIST_MAX_HEIGHT, overflowY: 'auto' }}>
                    {filtered.length == 0 &&
                        <span className="dropdown-item-text text-muted">{emptyText || 'No results found'}</span>}
                    {filtered.map((option, index) => (
                        <button
                            type="button"
                            key={option.value}
                            className={"dropdown-item" + (index == highlight ? ' active' : '')}
                            style={{ whiteSpace: 'normal' }}
                            // mousedown so it runs before the input loses focus
                            onMouseDown={(e) => { e.preventDefault(); this.select(option); }}
                            onMouseEnter={() => this.setState({ highlight: index })}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>}
            </div>
        );
    }
}
export default SearchableSelect;
